const dynamic_CN_Locale = {
    'dynamic.newsUpdates': '新闻动态',
    'dynamic.Intelligently': '智能重塑超声医学影像',
    'dynamic.moreContent': '更多内容',
    'dynamic.rightTitle1': '喜报！度影医疗获批乳腺超声影像处理软件NMPA注册证',
    'dynamic.rightContent1': '6月12日，度影医疗乳腺超声影像处理软件（RayBreast）获广东省药品监督管理局颁发的NMPA二类医疗器械注册证，该证也是度影获得的第四张医疗器械注册证。新产品注册证的',
    'dynamic.rightTime1': '2024年06月14日',
    'dynamic.rightTitle2': '盖茨基金会专访丨倪东：我们想让最新的医疗进步, 为孕产妇保驾护航',
    'dynamic.rightTime2': '2024年05月14日',
    'dynamic.rightTitle3': '重磅首证! 度影医疗获批产前超声全孕周全参数软件NMPA注册证!',
    'dynamic.rightTime3': '2024年05月11日',
    'dynamic.rightTitle4': '首创胎心CTIs正常值参考！度影医疗联合苏州市立医院发表胎心超声智能分析顶级期刊论文',
    'dynamic.rightTime4': '2024年01月30日',
    'dynamic.rightTitle5': '智能超声丨度影医疗联合深圳市宝安中医院发表智能盆底超声高水平论文',
    'dynamic.rightTime5': '2024年05月09日',
    'dynamic.viewDetails': '查看详情',
    'dynamic.dynamic1': '智领医美新纪元丨度影医疗与DJM德科医美、深圳市人民医院战略合作签约',
    'dynamic.dynamic1Content': '2025年1月2日，度影医疗携DJM德科医美、深圳市人民医院隆重举行医美超声AI战略合作签约仪式，并取得圆满成功。此次签约标志着医美行业在追求更规范、更严肃、更智能、更互信的发展道路上迈出了坚实的一步，更预示着一个由超声+AI赋能的全新医美时代即将到来。',
    'dynamic.dynamic2': '智能超声丨度影医疗联合广州中医药大学发表乳腺容积超声AI诊断的国际顶刊论文',
    'dynamic.dynamic3': '智能超声丨度影医疗联合暨南大学发表早孕期胎儿唇腭裂三维超声智能分析高水平论文',
    'dynamic.dynamic4': '智能超声丨度影医疗联合澳门理工大学发表超声影像质量控制算法高水平论文',
    'dynamic.dynamic5': '心动AI奖丨度影医疗罕见病超声AI筛查闪耀武田创新挑战赛！',
    'dynamic.dynamic6': '喜讯！度影医疗首席科学家倪东教授任医学影像国际顶级期刊IEEE TMI副主编',

}
export default dynamic_CN_Locale
